document.addEventListener('DOMContentLoaded', function () {
	const searchFormContainers = document.querySelectorAll('.search-form-container');
	searchFormContainers.forEach((container)=>{
		const searchBtn = container.parentElement.querySelector('.nav-search-btn');
		const searchInput = container.querySelector('.search-input');
		const closeBtn = container.querySelector('.search-close-btn');

		if (searchBtn && container) {
			searchBtn.addEventListener('click', function () {
				searchInput.focus();
				container.setAttribute('aria-hidden', 'false');
				searchBtn.setAttribute('aria-expanded', 'true');
			});

			closeBtn.addEventListener('click', function () {
				container.setAttribute('aria-hidden', 'true');
				searchBtn.setAttribute('aria-expanded', 'false');
			});
		}
	})

});
